import { render, staticRenderFns } from "./UpcomingEventHorizontal.vue?vue&type=template&id=09e19efa&scoped=true"
import script from "./UpcomingEventHorizontal.vue?vue&type=script&lang=js"
export * from "./UpcomingEventHorizontal.vue?vue&type=script&lang=js"
import style0 from "./UpcomingEventHorizontal.vue?vue&type=style&index=0&id=09e19efa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e19efa",
  null
  
)

export default component.exports